import styles from './DocumentIsEmpty.module.scss';

const DocumentIsEmpty = ({ title, text }: { text: string; title: string }) => {
    return (
        <div className={styles.containerEmpty}>
            <img
                className={styles.imageEmpty}
                src="/images/memberships/clients-notfound.svg"
                alt="No documents yet"
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                <p className={styles.descriptionEmpty}>{text}</p>
            </div>
        </div>
    );
};

export default DocumentIsEmpty;
